export const content = {
    domain: "NetCredit",
    footer: "netcedlt.com",
    title1: "Your Loan is Just a Few Steps Away!",
  };
  